import React, { useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import { api } from "../../../../api/audit-log";
import Pagination from "../../../../components/pagination/Pagination";
import Search from "../../../../components/Inputs/Search";
import { ScaleLoader } from "react-spinners";
import moment from "moment";

const METHOD_OPTIONS = ["GET", "POST", "PUT", "PATCH", "DELETE"];

const AuditLog = () => {
  const [perPage, setPerPage] = useState(25);
  const [path, setPath] = useState("");
  const [method, setMethod] = useState("");
  const [statusCode, setStatusCode] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const user = JSON.parse(window.sessionStorage.getItem("user"));
  const orgId = user?.org?.id;
  const isClientAdmin = user?.role?.slug === "client-admin";

  const { data: logs, isLoading } = useQuery(
    ["audit-logs", path, method, statusCode, perPage, currentPage],
    async () =>
      api.getAuditLogs({
        ...(isClientAdmin ? { orgId } : {}),
        path,
        method,
        statusCode,
        perPage,
        currentPage,
      }),
    {
      cacheTime: 100,
      staleTime: 100,
      onError: (error) => {
        toast.error(error?.response?.data?.message || "Failed to load audit logs");
      },
    }
  );

  const rows = logs?.data || [];

  return (
    <div className="">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-[#091F46] mb-3">Audit Log</h3>
      </div>

      <div className="p-4 md:p-6 overflow-auto ">
        <div className="flex justify-between items-center mb-3 flex-wrap gap-3">
          <h3 className="text-lg font-semibold text-[#091F46] ">Activity</h3>
          <div className="flex gap-3 justify-end flex-wrap items-center">
            <select
              value={method}
              onChange={(e) => {
                setCurrentPage(1);
                setMethod(e.target.value);
              }}
              className="text-xs border border-slate-300 rounded-md py-2.5 px-2 text-slate-600 focus:ring-0 outline-none focus:border-customBlue"
            >
              <option value="">All methods</option>
              {METHOD_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Status code"
              value={statusCode}
              onChange={(e) => {
                setCurrentPage(1);
                setStatusCode(e.target.value);
              }}
              className="text-xs border border-slate-300 rounded-md py-2.5 px-3 w-[110px] text-slate-600 focus:ring-0 outline-none focus:border-customBlue"
            />
            <Search
              onChange={(value) => {
                setCurrentPage(1);
                setPath(value);
              }}
              placeholder={"Search by path..."}
              className={"w-fit"}
            />
          </div>
        </div>

        <div className="bg-white p-3 rounded-lg shadow-sm">
          {isLoading ? (
            <div className="mt-10 flex justify-center items-center">
              <ScaleLoader color="#FF9100" />
            </div>
          ) : (
            <div className="mt-4 ">
              <div className="">
                <table className="table-container">
                  <thead className="table-header">
                    <tr>
                      <th className="table-head text-left">No</th>
                      <th className="table-head text-left">Actor</th>
                      <th className="table-head text-left">Role</th>
                      <th className="table-head">Method</th>
                      <th className="table-head text-left">Path</th>
                      <th className="table-head">Status</th>
                      <th className="table-head">IP Address</th>
                      <th className="table-head">Date</th>
                    </tr>
                  </thead>

                  <tbody className="table-body text-xs">
                    {rows.length > 0 ? (
                      rows.map((log, index) => (
                        <tr key={log.id || index}>
                          <td className="table-data">
                            {(currentPage - 1) * perPage + index + 1}
                          </td>
                          <td className="table-data text-left">
                            {log.actorEmail || "Unauthenticated"}
                          </td>
                          <td className="table-data text-left">
                            {log.roleName || "—"}
                          </td>
                          <td className="table-data">{log.method}</td>
                          <td className="table-data text-left break-all">
                            {log.path}
                          </td>
                          <td
                            className={`table-data font-semibold ${
                              log.statusCode >= 400 ? "text-red-500" : "text-green-600"
                            }`}
                          >
                            {log.statusCode}
                          </td>
                          <td className="table-data">{log.ipAddress || "—"}</td>
                          <td className="table-data">
                            {moment(log.createdAt).format("YYYY/MM/DD, h:mm a")}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="table-data" colSpan="8">
                          <p className="text-center">No Data Available</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <section className={`mt-1 px-3 rouded-lg bg-white`}>
            <Pagination
              data={logs?.meta}
              perPage={perPage}
              pageNo={currentPage}
              setPageNo={setCurrentPage}
              setPerPage={setPerPage}
            />
          </section>
        </div>
      </div>
    </div>
  );
};

export default AuditLog;
